import { createSlice } from '@reduxjs/toolkit';

import initialState from './initialState';
import { STATUS_TYPES } from '../../constants';

const profileSettingsSlice = createSlice({
  name: 'profileSettings',
  initialState,
  reducers: {
    profileSettingsFetching(state) {
      state.status = STATUS_TYPES.INIT_STATE;
    },
    profileSettingsSucceeded(state, { payload }) {
      state.status = STATUS_TYPES.SUCCEED_STATE;
      state.data = payload;
    },
    profileSettingsFailed(state, { payload }) {
      state.status = STATUS_TYPES.FAILED_STATE;
      state.error = {
        status: payload?.status,
        message: payload?.message,
      };
    },
    clearProfileSettings() {
      return initialState;
    },
  },
});

export const {
  profileSettingsFetching,
  profileSettingsSucceeded,
  profileSettingsFailed,
  clearProfileSettings,
} = profileSettingsSlice.actions;

export default profileSettingsSlice.reducer;
